import { SvgIconProps } from '@mui/material';

const NewArrowLeft = ({ width = '44', height = '111', className }: SvgIconProps) => (
  <svg width={width} height={height} viewBox="0 0 44 111" fill="none" className={className}>
    <path
      d="M7.00136 14V93.217C7.00136 102.054 14.1648 109.217 23.0014 109.217H41.8789"
      stroke="#E8E6DF"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M4.97766 1.60505C5.71471 0.130954 7.81832 0.130955 8.55537 1.60505L13.3193 11.1329C13.9842 12.4627 13.0172 14.0273 11.5304 14.0273L2.00258 14.0273C0.515816 14.0273 -0.451175 12.4627 0.213726 11.1329L4.97766 1.60505Z"
      fill="#E8E6DF"
    />
  </svg>
);

export default NewArrowLeft;
